var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5001 4.8149C11.5001 7.10586 9.70926 8.96305 7.50012 8.96305C5.29098 8.96305 3.50012 7.10586 3.50012 4.8149C3.50012 2.52394 5.29098 0.666748 7.50012 0.666748C9.70926 0.666748 11.5001 2.52394 11.5001 4.8149ZM14.5 18.2964C14.5 18.8691 14.0523 19.3334 13.5 19.3334H1.5C0.947715 19.3334 0.5 18.8691 0.5 18.2964C0.5 14.2872 3.63401 11.0371 7.5 11.0371C11.366 11.0371 14.5 14.2872 14.5 18.2964Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonOverview);
export default __webpack_public_path__ + "static/media/person-overview.a1d1e9cf20e71745be7fd244d38f88d5.svg";
export { ForwardRef as ReactComponent };